module.exports = __webpack_public_path__ + "images/shuffle_grey@2x.png?5e93ac39";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shuffle_grey@2x.png
// module id = 705
// module chunks = 7